/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import './styles.css';

const EditHint = () => (
  <FontAwesomeIcon size="sm" className="ml-2 cursor-pointer" icon={faEdit} aria-hidden="true" />
);

const SectionInfoCard = ({ sectionName, sectionCode, onEditClick }) => {
  return (
    <Card className="survey-info-card cursor-pointer" onClick={onEditClick}>
      <Card.Body>
        <div>
          <h4 className="mb-2">
            Section Name
            <EditHint />
          </h4>
          <span>{sectionName}</span>
        </div>
        <div className="pt-3">
          <h4 className="mb-2">Section Code</h4>
          <span>{sectionCode}</span>
        </div>
      </Card.Body>
    </Card>
  );
};

SectionInfoCard.propTypes = {
  sectionName: PropTypes.string.isRequired,
  sectionCode: PropTypes.string,
  onEditClick: PropTypes.func.isRequired,
};

export default SectionInfoCard;
